var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEc2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16049_193661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2129 0.732422H0.212891V24.7324H24.2129V0.732422Z",
    fill: "#ED7100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46289 16.1074H15.5879V9.35742H8.46289V16.1074ZM16.3379 9.35742H17.4629V10.1074H16.3379V10.8574H17.4629V11.6074H16.3379V12.3574H17.4629V13.1074H16.3379V14.2324H17.4629V14.9824H16.3379V15.7324H17.4629V16.4824H16.2865C16.1909 16.7025 15.9715 16.8574 15.7169 16.8574H15.5879V17.9824H14.8379V16.8574H14.0879V17.9824H13.3379V16.8574H12.5879V17.9824H11.8379V16.8574H11.0879V17.9824H10.3379V16.8574H9.21289V17.9824H8.46289V16.8574H8.33389C8.07927 16.8574 7.85989 16.7025 7.76427 16.4824H6.96289V15.7324H7.71289V14.9824H6.96289V14.2324H7.71289V13.1074H6.96289V12.3574H7.71289V11.6074H6.96289V10.8574H7.71289V10.1074H6.96289V9.35742H7.71289V9.22842C7.71289 8.88605 7.99152 8.60742 8.33389 8.60742H8.46289V7.48242H9.21289V8.60742H10.3379V7.48242H11.0879V8.60742H11.8379V7.48242H12.5879V8.60742H13.3379V7.48242H14.0879V8.60742H14.8379V7.48242H15.5879V8.60742H15.7169C16.0593 8.60742 16.3379 8.88605 16.3379 9.22842V9.35742ZM12.2129 20.2324H4.71289V12.7324H6.21289V11.9824H4.65402C4.27264 11.9824 3.96289 12.2925 3.96289 12.6735V20.2913C3.96289 20.6723 4.27264 20.9824 4.65402 20.9824H12.2718C12.6531 20.9824 12.9629 20.6723 12.9629 20.2913V18.7324H12.2129V20.2324ZM20.4629 5.17355V12.7913C20.4629 13.1723 20.1531 13.4824 19.7718 13.4824H18.2129V12.7324H19.7129V5.23242H12.2129V6.73242H11.4629V5.17355C11.4629 4.79255 11.7726 4.48242 12.154 4.48242H19.7718C20.1531 4.48242 20.4629 4.79255 20.4629 5.17355Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16049_193661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.212891 0.732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc2);
export default __webpack_public_path__ + "static/media/EC2.dfe7878dc0bf304d71b09912c527a0bd.svg";
export { ForwardRef as ReactComponent };